import { RefObject, useEffect, useCallback } from 'react';

const useClickOutside = (
  ref: RefObject<HTMLElement | null>,
  handler: () => void
) => {
  const memoizedHandler = useCallback(handler, [handler]);

  useEffect(() => {
    const listener = (e: MouseEvent) => {
      if (!ref?.current) return;

      const path = e.composedPath?.() || [];
      const isOutside = !path.includes(ref.current);

      if (isOutside) {
        memoizedHandler();
      }
    };

    document.addEventListener('click', listener);

    return () => {
      document.removeEventListener('click', listener);
    };
  }, [ref, memoizedHandler]);
};

export default useClickOutside;
